import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from './shell/AppShell';
import { RequireAdvisor } from './shell/RequireAdvisor';
import { FirmProvider } from './lib/firm/FirmProvider';
import { SignInScreen } from './screens/SignInScreen';
import { SetPasswordScreen } from './screens/SetPasswordScreen';
import { DashboardScreen } from './screens/DashboardScreen';
import { ClientsScreen } from './screens/ClientsScreen';
import { ClientDetailScreen } from './screens/ClientDetailScreen';
import { RecoveriesScreen } from './screens/RecoveriesScreen';
import { AttestationsScreen } from './screens/AttestationsScreen';
import { EventsScreen } from './screens/EventsScreen';
import { InvitesScreen } from './screens/InvitesScreen';
import { AuditLogScreen } from './screens/AuditLogScreen';
import { BrandingScreen } from './screens/BrandingScreen';
import { TeamScreen } from './screens/TeamScreen';
import { NotFoundScreen } from './screens/NotFoundScreen';

export const router = createBrowserRouter([
  { path: '/signin', element: <SignInScreen /> },
  // Public: this is where the emailed set-password link lands, and the person
  // following it has no session yet by definition.
  { path: '/set-password', element: <SetPasswordScreen /> },
  {
    path: '/',
    element: (
      <RequireAdvisor>
        <FirmProvider>
          <AppShell />
        </FirmProvider>
      </RequireAdvisor>
    ),
    errorElement: <NotFoundScreen />,
    children: [
      { index: true, element: <DashboardScreen /> },
      { path: 'clients', element: <ClientsScreen /> },
      { path: 'clients/:vaultId', element: <ClientDetailScreen /> },
      { path: 'attestations', element: <AttestationsScreen /> },
      // Firm administrators only — the server refuses anyone else, and the
      // nav hides it, but the route stays reachable so a stale link explains
      // itself rather than 404ing.
      { path: 'team', element: <TeamScreen /> },
      // Clients locked out of their own vaults. Attestation is the fast door
      // and had no handle until this screen existed.
      { path: 'recoveries', element: <RecoveriesScreen /> },
      { path: 'events', element: <EventsScreen /> },
      { path: 'invites', element: <InvitesScreen /> },
      { path: 'audit', element: <AuditLogScreen /> },
      { path: 'branding', element: <BrandingScreen /> },
    ],
  },
  { path: '*', element: <NotFoundScreen /> },
]);
